import React from 'react'
import type { PaymentHistoryEntry } from '../Utils/types'
import PaymentActivityLog from '../PaymentActivityLog'

interface ActivityLogSectionProps {
  activityLogs: PaymentHistoryEntry[]
}

export function ActivityLogSection({ activityLogs }: ActivityLogSectionProps) {
  return <PaymentActivityLog activityLogs={activityLogs} />
}
